import Vue from 'vue'
import {BadgePlugin, BootstrapVue} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'
import VueSweetalert2 from 'vue-sweetalert2';
import VueInputRestrictionDirectives from 'vue-input-restriction-directives';
import "../src/design/app.scss";
import store from '@/state/store'
import App from './App.vue'
import Croppa from 'vue-croppa';
import VModal from 'vue-js-modal/dist/index.nocss.js'
import 'vue-js-modal/dist/styles.css'
import i18n from './i18n'
import 'flag-icon-css/css/flag-icon.css'
// Http Config
import http from './http'
// Auth Config
import config from './config'
// Vue Filters
import {registeredFilters} from './filters'
// Vue GlobalComponents
import {globalComponents} from './global'
// Vue File Agent
import VueFileAgent from 'vue-file-agent';
import 'vue-file-agent/dist/vue-file-agent.css';
// Vue 2 Clipboard
import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true
// Helper
import helpers from './helpers'
// Echo
import Echo from "laravel-echo";
// Country Select
import vueCountryRegionSelect from 'vue-country-region-select'
// Vue Animatecss
import VAnimateCss from 'v-animate-css';
// Yandex Metrika
import VueYandexMetrika from 'vue-yandex-metrika'
// VueAnalytics
import VueAnalytics from 'vue-analytics'
// Vue Tour
import VueTour from 'vue-tour'
require('vue-tour/dist/vue-tour.css')
// Vue click outside
import vClickOutside from 'v-click-outside'
// TawkTo
import TawkMessengerVue from '@tawk.to/tawk-messenger-vue-2';

// Helper Plugin
const helperPlugin = {
    install() {
        Vue.helpers = helpers
        Vue.prototype.$helpers = helpers
    },
}

// Mobile Screen Checker
function onResize() {
    store.dispatch('app/changeIsMobile')
}

window.addEventListener('resize', onResize, {passive: true})

// Pusher
window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.VUE_APP_MIX_PUSHER_APP_KEY,
    cluster: process.env.VUE_APP_MIX_PUSHER_APP_CLUSTER,
    authEndpoint: process.env.VUE_APP_URL + '/api/broadcasting/auth',
    authorizer: (channel) => {
        return {
            authorize: (socketId, callback) => {
                Vue.axios.post('/api/broadcasting/auth?notificationOff', {
                    socket_id: socketId,
                    channel_name: channel.name
                }, {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('sellerdeskai-auth')
                    }
                })
                    .then(response => {
                        callback(false, response.data);
                    })
                    .catch(error => {
                        callback(true, error);
                    });
            }
        };
    },
})


// Vue Use
Vue.use(VModal)
Vue.use(VueInputRestrictionDirectives)
Vue.use(BadgePlugin)
Vue.use(VueRouter)
Vue.use(vco)
Vue.use(Croppa);
Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
Vue.use(VueSweetalert2);
Vue.use(VueFileAgent);
Vue.use(VueClipboard);
Vue.use(helperPlugin);
Vue.use(vueCountryRegionSelect)
Vue.use(VAnimateCss);
Vue.use(VueTour);
Vue.use(vClickOutside);


Vue.use(VueYandexMetrika, {
    id: process.env.VUE_APP_YANDEX_ID,
    router: router,
    env: process.env.VUE_APP_NODE_ENV
})

Vue.use(VueAnalytics, {
    id: process.env.VUE_APP_GOOGLE_ID,
    checkDuplicatedScript: true,
    router,
    debug: {
        sendHitTask: process.env.VUE_APP_NODE_ENV === 'production'
    }
})


if (process.env.VUE_APP_NODE_ENV === 'production') {
    Vue.use(TawkMessengerVue, {
        propertyId : process.env.VUE_APP_PROPERTY_ID,
        widgetId : process.env.VUE_APP_WIDGET_ID
    });
}

// Vue Component
Vue.component('apexchart', VueApexCharts)

// Global Variables
Vue.prototype.$clientUrl = process.env.VUE_APP_CLIENT_URL;

// Vue Filters
registeredFilters()

// Vue Global Pages
globalComponents()

Vue.config.productionTip = false

new Vue({
    router,
    store,
    i18n,
    http,
    config,
    render: h => h(App)
}).$mount('#app')
